import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'apps/artisan/src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  LoginMFAReq,
  LoginMFARes,
  VerifyMFAReq,
  VerifyMFARes,
  EnrollMFAReq,
  EnrollMFARes,
  ActivateMFAReq,
  ActivateMFARes,
  SuretyRes
} from './def/custom-login';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { appendRelativePathToUrl } from '@tmhcc/util';
import { GlobalVariablesService } from './global-variables.service';
import OktaAuth from '@okta/okta-auth-js';
import { OktaConfig, OKTA_CONFIG } from '@okta/okta-angular';

@Injectable({
  providedIn: 'root'
})
export class CustomLoginService extends BaseDataService {
  public authClient;

  public isAuthenticated = new BehaviorSubject<boolean>(false);

  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService,
    @Inject(OKTA_CONFIG) protected configs: OktaConfig
  ) {
    super(http, configService, globalVariables);
    // this.authClient = new OktaAuth({
    //   issuer: this.configs.issuer,// 'https://{YourOktaDomain}/oauth2/default',
    //   clientId: this.configs.clientId// '{ClientId}'
    // });
  }

  loginMFA(params: LoginMFAReq): Observable<LoginMFARes> {
    const url = this.getServiceUrl('authentication/login-api');
    return this.post<LoginMFARes>(url, { body: params }, false, false);
  }

  verifySMS(params: VerifyMFAReq): Observable<VerifyMFARes> {
    const url = this.getServiceUrl('authentication/mfa/sms/verify');
    return this.post<VerifyMFARes>(url, { body: params }, false, false);
  }

  verifyVoice(params: VerifyMFAReq): Observable<VerifyMFARes> {
    const url = this.getServiceUrl('authentication/mfa/voice-call/verify');
    return this.post<VerifyMFARes>(url, { body: params }, false, false);
  }

  enrollSMS(params: EnrollMFAReq): Observable<EnrollMFARes> {
    const url = this.getServiceUrl('authentication/mfa/sms/enroll');
    return this.post<EnrollMFARes>(url, { body: params }, false, false);
  }
  enrollVoice(params: EnrollMFAReq): Observable<EnrollMFARes> {
    const url = this.getServiceUrl('authentication/mfa/voice-call/enroll');
    return this.post<EnrollMFARes>(url, { body: params }, false, false);
  }

  activateSMS(params: ActivateMFAReq): Observable<ActivateMFARes> {
    const url = this.getServiceUrl('authentication/mfa/sms/enroll/activate');
    return this.post<ActivateMFARes>(url, { body: params }, false, false);
  }
  activateVoice(params: ActivateMFAReq): Observable<ActivateMFARes> {
    const url = this.getServiceUrl(
      'authentication/mfa/voice-call/enroll/activate'
    );
    return this.post<ActivateMFARes>(url, { body: params }, false, false);
  }

  getServiceUrl(servicePath: string): string {
    return appendRelativePathToUrl(
      environment.oktaWidgetConfig.issuer,
      servicePath
    );
  }

  // isAuthenticated() {
  //   const token = sessionStorage.getItem('token');
  //   if (token) {
  //     return true;
  //   }
  // }
  getUser() {
    const userId = sessionStorage.getItem('user');
    if (userId) {
      return userId;
    }
  }

  loginOkta(stateToken: string) {
    // const transaction = await this.authClient.signIn({username, password}); //internal login required for utilizing Okta inbuild authentication session.

    // if (transaction.status !== 'SUCCESS') {
    //   throw Error('We cannot handle the ' + transaction.status + ' status');
    // }
    this.isAuthenticated.next(true);

    //this.authClient.session.setCookieAndRedirect(stateToken);
  }

  loginSurety(): Observable<SuretyRes> {
    const url = `${this.serviceBaseUrl}/authentication/external-surety-link`;
    return this.get<SuretyRes>(url);
  }
}
